import AdminEmailNotificationSetting from './AdminEmailNotificationSetting.json';
import AuditLogs from './AuditLogs.json';
import ClientAllowanceItems from './ClientAllowanceItems.json';
import ClientAllowances from './ClientAllowances.json';
import ClientAllowedIpSetting from './ClientAllowedIpSetting.json';
import ClientBonusAllowances from './ClientBonusAllowances.json';
import ClientCommutingFeeSetting from './ClientCommutingFeeSetting.json';
import ClientCustomFeatures from './ClientCustomFeatures.json';
import ClientCsvFormats from './ClientCsvFormats.json';
import ClientMotivation from './ClientMotivation.json';
import ClientPaidPlan from './ClientPaidPlan.json';
import ClientUnitPrices from './ClientUnitPrices.json';
import Clients from './Clients.json';
import Coordinations from './Coordinations.json';
import Dashboard from './Dashboard.json';
import Desk from './Desk.json';
import EmployeeAttendances from './EmployeeAttendances.json';
import EmployeeBonus from './EmployeeBonus.json';
import EmployeeInvitations from './EmployeeInvitations.json';
import EmployeePays from './EmployeePays.json';
import Employees from './Employees.json';
import ErrorPage from './ErrorPage.json';
import GuideTour from './GuideTour.json';
import Memos from './Memos.json';
import MyData from './MyData.json';
import PayrollRulesGroups from './PayrollRulesGroups.json';
import Registrations from './Registrations.json';
import ReportIncomeTax from './ReportIncomeTax.json';
import ReportPnd from './ReportPnd.json';
import Reports from './Reports.json';
import ReportSocialSecurityOffices from './ReportSocialSecurityOffices.json';
import RoleUsers from './RoleUsers.json';
import Settings from './Settings.json';
import Users from './Users.json';
import YearEndReportKt20Kors from './YearEndReportKt20Kors.json';
import YearEndReportPndKor from './YearEndReportPndKor.json';
import YearEndReportWithholdingReports from './YearEndReportWithholdingReports.json';
import YearEndReports from './YearEndReports.json';
import YearEndReportTaxDeductionCerts from './YearEndReportTaxDeductionCerts.json';

export default {
  features: {
    AdminEmailNotificationSetting,
    AuditLogs,
    ClientAllowanceItems,
    ClientAllowances,
    ClientAllowedIpSetting,
    ClientBonusAllowances,
    ClientCommutingFeeSetting,
    ClientCsvFormats,
    ClientMotivation,
    ClientPaidPlan,
    ClientUnitPrices,
    Clients,
    Coordinations,
    Dashbord: Dashboard,
    Desk,
    EmployeeAttendances,
    EmployeeBonus,
    EmployeeInvitations,
    EmployeePays,
    Employees,
    ErrorPage,
    GuideTour,
    Memos,
    MyData,
    PayrollRulesGroups,
    Registrations,
    ReportIncomeTax,
    ReportPnd,
    Reports,
    ReportSocialSecurityOffices,
    RoleUsers,
    Settings,
    Users,
    YearEndReportKt20Kors,
    YearEndReportPndKor,
    YearEndReportWithholdingReports,
    YearEndReports,
    YearEndReportTaxDeductionCerts,
    ClientCustomFeatures
  }
};
